import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-service-data-form-carrier-condition',
  imports: [TranslatePipe, ValidationErrorComponent, ReactiveFormsModule],
  templateUrl: './service-data-form-carrier-condition.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormCarrierConditionComponent implements OnInit {
  private controlContainer = inject(ControlContainer);
  private destroyRef = inject(DestroyRef);

  public title = input.required<string>();
  public validationTranslation = input<string>();
  public property = input.required<string>();
  public descriptionProperty = input<string>();
  public descriptionTitle = input<string>();
  public descriptionPlaceholder = input<string>();
  public fieldSet = input<string[]>([]);
  public field = input<string>();

  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  ngOnInit(): void {
    const descriptionProperty = this.descriptionProperty();

    if (!descriptionProperty) {
      return;
    }

    this.form
      .get(this.property())
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: boolean) => {
        if (!value) {
          this.form.get(descriptionProperty).reset(null);
        }
      });
  }
}
